import React from 'react';
import { NavLink } from 'react-router-dom';

import Holder from './../../../../themes/nerdify/components/Holder';
import TextPage from './../TextPage';
import LocalesPage from './../LocalesPage';

import { REACT_APP_CONTACT_EMAIL } from './../../../../config';

export default (props) => (
  <LocalesPage {...props}>
    <TextPage>
      <Holder className="holder_1">
        <h1 className="h1">Nerdify SMS Policy</h1>
        <p className="p italic">Effective Date: September 2, 2025</p>

        <div className="textPage-item">
          <p className="p">This SMS Policy outlines the terms and conditions for receiving SMS messages from Nerdify via sms, text and mobile communication. By opting in to receive SMS messages from us, you agree to these terms.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">1. Program Description:</h2>
          <p className="p">Nerdify uses SMS (Short Message Service) to provide order updates, important alerts, service notifications and promotional offers. Messages will be sent from our dedicated number 32096.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">2. Opt-In/Consent:</h2>
          <p className="p">You can opt-in to receive SMS messages from Nerdify by checking a box on our website form or providing your phone number during checkout. By opting in, you authorize Nerdify to send you recurring SMS messages. Message frequency will vary.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">3. Cost:</h2>
          <p className="p">Message and data rates may apply. Please consult your mobile carrier for details on your plan's message and data rates. Nerdify does not charge for the SMS messages you receive.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">4. Opt-Out/Stop:</h2>
          <p className="p">You can opt-out of receiving SMS messages from Nerdify at any time by texting <span className="strong">STOP</span> to 32096. You will receive one final message confirming your opt-out. After this, you will no longer receive SMS messages from us from that Short Code.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">5. Help/Support:</h2>
          <p className="p">If you are experiencing issues with the messaging program, reply with the keyword HELP for more assistance, or you can get help directly by emailing <a className="a" href={'mailto:' + REACT_APP_CONTACT_EMAIL} target="_blank" rel="noopener noreferrer">{REACT_APP_CONTACT_EMAIL}</a>.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">6. Supported Carriers:</h2>
          <p className="p">Our SMS service is available on all major U.S. mobile carriers including, but not limited to, AT&amp;T, T-Mobile, Verizon Wireless, Sprint, Boost Mobile, MetroPCS, U.S. Cellular, and Virgin Mobile. Message and data rates may apply.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">7. Privacy:</h2>
          <p className="p">We respect your privacy. Your mobile number and personal information will be kept confidential and will not be shared or sold to third parties for marketing purposes. For more information, please review our full <NavLink className="a" to="/privacy-policy">Privacy Policy</NavLink>.</p>
        </div>

        <div className="textPage-item">
          <h2 className="h3">8. Changes to this SMS Policy:</h2>
          <p className="p">Nerdify reserves the right to change this SMS Policy at any time. Any changes will be posted on this page. Your continued use of the SMS service after any such changes constitutes your acceptance of the new terms.</p>
        </div>
      </Holder>
    </TextPage>
  </LocalesPage>
);
